import { create } from 'zustand';

export interface AuthUser {
  id: string;
  tenantId: string;
  email: string;
  name: string | null;
  // 'external_reviewer' (Group B: authenticated external advisors/auditors) is a portal-only
  // role — App.tsx's ProtectedRoute redirects it to /reviewer before it ever reaches the main
  // app shell; every main-app API guard also positively rejects it server-side.
  role: 'tenant_admin' | 'r_and_d_manager' | 'member' | 'viewer' | 'developer' | 'external_reviewer';
}

interface AuthState {
  user: AuthUser | null;
  isLoading: boolean;
  setUser: (user: AuthUser | null) => void;
  setLoading: (loading: boolean) => void;
  clearUser: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: true,
  setUser: (user) => set({ user, isLoading: false }),
  setLoading: (isLoading) => set({ isLoading }),
  clearUser: () => set({ user: null, isLoading: false }),
}));
